import { postShareRecordsByResourceId } from "services/share";
import { ApiResponseError, handleOnError, ToastType, useApiRequest } from "./apiRequestContext";
import { useIdentity } from "./identityContext";
import { useMutation } from "@tanstack/react-query";
import { ShareRecordRequestType, ShareResourceDisplayType } from "services/share/types/share";

export function useShareRecordByResourceId(
    resource: ShareResourceDisplayType, 
    resourceId: string,
    onSuccess: (data: any) => void,
    setToast: React.Dispatch<React.SetStateAction<ToastType>>,
) {
    const { token } = useIdentity();
    const { startRequest, endRequest } = useApiRequest();

    return useMutation({
        mutationFn: async (payload: ShareRecordRequestType) => {
            startRequest();
            const { data } = await postShareRecordsByResourceId(resource, resourceId, payload, token!);
            endRequest(true);
            return data;
        },
        onSuccess,
        onError(error, _) {
            handleOnError(error as ApiResponseError, setToast)
        },
    });
}
